import React, { ReactNode } from 'react';
import styled from 'styled-components';

import IdiomSelector from '../IdiomSelector';
import { isTestingEnvironment } from '../../utils';
import SelectLayoutChecklistSite from './SelectLayoutChecklistSite';

interface IProps {
    children?: ReactNode;
}

const ChecklistSitePageContainer = ({ children }: IProps) => {
    return (
        <>
            {isTestingEnvironment() ? (
                <IdiomSelectorWrapper>
                    <IdiomSelector />
                </IdiomSelectorWrapper>
            ) : null}
            <SelectorWrapper>
                <SelectLayoutChecklistSite />
            </SelectorWrapper>
            {children}
        </>
    );
};

const SelectorWrapper = styled.div`
    position: absolute;
    top: ${({ theme }) => theme.spacing.s}px;
    right: ${({ theme }) => theme.spacing.m}px;
`;

const IdiomSelectorWrapper = styled.div`
    position: absolute;
    top: ${({ theme }) => theme.spacing.s}px;
    right: 300px;
`;

export default ChecklistSitePageContainer;
